// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/colors.module.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrgBudgetSetup-module_budget_list_table_x0CYs {
  width: 100%;
  border-spacing: 8px 10px;
  border-collapse: unset;
}

.OrgBudgetSetup-module_budget_list_table_compact_J8h7v {
  border-spacing: 4px 5px;
}

.OrgBudgetSetup-module_table_header_cell_WOiIZ {
  text-align: center;
  vertical-align: bottom;
  font-weight: 600;
}

.OrgBudgetSetup-module_money_cell_YbW9p {
  text-align: right;
  padding-right: 6px;
  padding-left: 6px;
}

.OrgBudgetSetup-module_total_label_upjyX {
  font-size: larger;
  vertical-align: middle !important;
  text-align: right;
  font-weight: 500;
}

.OrgBudgetSetup-module_table_total_cell_trbyG {
  font-size: larger;
  text-align: right;
  font-weight: 500;
  padding-right: 12px;
  padding-left: 12px;
}

.OrgBudgetSetup-module_alt_row_JQ_mk > td > div > div:has(label),
.OrgBudgetSetup-module_alt_row_JQ_mk > td > div input {
  background-color: var(--bp-light-gray3);
}

.OrgBudgetSetup-module_selected_row_gn9QD > td > div > div:has(label),
.OrgBudgetSetup-module_selected_row_gn9QD > td > div input {
  background-color: var(--selected-row-bg-color);
}

.OrgBudgetSetup-module_account_details_IIHHj {
  display: flex;
  align-items: center;
}

.OrgBudgetSetup-module_fiscal_year_selection_csuim {
  display: flex;
  align-items: center;
  justify-content: end;
  flex-shrink: 0;
}

.OrgBudgetSetup-module_fiscal_year_selection_csuim > span {
  font-weight: 600;
  text-align: right;
}

.OrgBudgetSetup-module_copy_from_box_cy1Hx {
  display: flex;
  align-items: center;
}

.OrgBudgetSetup-module_copy_from_box_disabled_MsrPw {
  /* opacity: 0.7; */
}

.OrgBudgetSetup-module_copy_from_box_disabled_MsrPw:hover {
  transform: translateY(0);
  box-shadow: none !important;
}

.OrgBudgetSetup-module_copy_from_box_cy1Hx:hover input {
  color: var(--primary-button-hover-color) !important;
}

.OrgBudgetSetup-module_copy_from_button_T04Qb {
}

.OrgBudgetSetup-module_copy_from_box_cy1Hx input,
.OrgBudgetSetup-module_copy_from_box_disabled_MsrPw:hover span,
.OrgBudgetSetup-module_copy_from_box_disabled_MsrPw .OrgBudgetSetup-module_copy_from_button_T04Qb:hover span {
  color: var(--primary-bos-color) !important;
}

.OrgBudgetSetup-module_copy_from_box_disabled_MsrPw:hover,
.OrgBudgetSetup-module_copy_from_box_cy1Hx .OrgBudgetSetup-module_copy_from_button_T04Qb:hover {
  transform: translateY(0);
  box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/client/pages/Accounts/Budgets/OrgBudgetSetup.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EAEE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;AAEA;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;;EAEE,wBAAwB;EACxB,2BAA2B;AAC7B","sourcesContent":[".budget_list_table {\n  width: 100%;\n  border-spacing: 8px 10px;\n  border-collapse: unset;\n}\n\n.budget_list_table_compact {\n  composes: budget_list_table;\n  border-spacing: 4px 5px;\n}\n\n.table_header_cell {\n  text-align: center;\n  vertical-align: bottom;\n  font-weight: 600;\n}\n\n.money_cell {\n  text-align: right;\n  padding-right: 6px;\n  padding-left: 6px;\n}\n\n.total_label {\n  font-size: larger;\n  vertical-align: middle !important;\n  text-align: right;\n  font-weight: 500;\n}\n\n.table_total_cell {\n  font-size: larger;\n  text-align: right;\n  font-weight: 500;\n  padding-right: 12px;\n  padding-left: 12px;\n}\n\n.alt_row > td > div > div:has(label),\n.alt_row > td > div input {\n  background-color: var(--bp-light-gray3);\n}\n\n.selected_row > td > div > div:has(label),\n.selected_row > td > div input {\n  background-color: var(--selected-row-bg-color);\n}\n\n.account_details {\n  composes: row_selected_background from 'Styles/colors.module.css';\n  display: flex;\n  align-items: center;\n}\n\n.fiscal_year_selection {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  flex-shrink: 0;\n}\n\n.fiscal_year_selection > span {\n  font-weight: 600;\n  text-align: right;\n}\n\n.copy_from_box {\n  composes: primary_button_outlined from 'Styles/styles.module.css';\n  display: flex;\n  align-items: center;\n}\n\n.copy_from_box_disabled {\n  composes: copy_from_box;\n  /* opacity: 0.7; */\n}\n\n.copy_from_box_disabled:hover {\n  transform: translateY(0);\n  box-shadow: none !important;\n}\n\n.copy_from_box:hover input {\n  color: var(--primary-button-hover-color) !important;\n}\n\n.copy_from_button {\n  composes: primary_button_minimal from 'Styles/styles.module.css';\n}\n\n.copy_from_box input,\n.copy_from_box_disabled:hover span,\n.copy_from_box_disabled .copy_from_button:hover span {\n  color: var(--primary-bos-color) !important;\n}\n\n.copy_from_box_disabled:hover,\n.copy_from_box .copy_from_button:hover {\n  transform: translateY(0);\n  box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"budget_list_table": `OrgBudgetSetup-module_budget_list_table_x0CYs`,
	"budget_list_table_compact": `OrgBudgetSetup-module_budget_list_table_compact_J8h7v OrgBudgetSetup-module_budget_list_table_x0CYs`,
	"table_header_cell": `OrgBudgetSetup-module_table_header_cell_WOiIZ`,
	"money_cell": `OrgBudgetSetup-module_money_cell_YbW9p`,
	"total_label": `OrgBudgetSetup-module_total_label_upjyX`,
	"table_total_cell": `OrgBudgetSetup-module_table_total_cell_trbyG`,
	"alt_row": `OrgBudgetSetup-module_alt_row_JQ_mk`,
	"selected_row": `OrgBudgetSetup-module_selected_row_gn9QD`,
	"account_details": `OrgBudgetSetup-module_account_details_IIHHj ${___CSS_LOADER_ICSS_IMPORT_0___.locals["row_selected_background"]}`,
	"fiscal_year_selection": `OrgBudgetSetup-module_fiscal_year_selection_csuim`,
	"copy_from_box": `OrgBudgetSetup-module_copy_from_box_cy1Hx ${___CSS_LOADER_ICSS_IMPORT_1___.locals["primary_button_outlined"]}`,
	"copy_from_box_disabled": `OrgBudgetSetup-module_copy_from_box_disabled_MsrPw OrgBudgetSetup-module_copy_from_box_cy1Hx ${___CSS_LOADER_ICSS_IMPORT_1___.locals["primary_button_outlined"]}`,
	"copy_from_button": `OrgBudgetSetup-module_copy_from_button_T04Qb ${___CSS_LOADER_ICSS_IMPORT_1___.locals["primary_button_minimal"]}`
};
export default ___CSS_LOADER_EXPORT___;
